import { CONSTANTS } from "src/app/constants";
import { Uom } from "../../storage/models/uom.model";

const { UNITS } = CONSTANTS;

export class ModelWithUnitsOfMeasure {
  uoms: Uom[]

  constructor(uoms: Uom[]) {
    this.uoms = uoms;
  }
  
  get weightUom(): string {
    const uom = this.uoms.find(uom => uom.codeInternal === UNITS.WEIGHT);
    return uom ? uom.uomDisplay : UNITS.WEIGHT;
  }

  get tonUom(): string {
      const uom = this.uoms.find(uom => uom.codeInternal === UNITS.TON);
      return uom ? uom.uomDisplay : UNITS.WEIGHT;
  }

  get volumeUom(): string {
      const uom = this.uoms.find(uom => uom.codeInternal === UNITS.VOLUME);
      return uom ? uom.uomDisplay : UNITS.WEIGHT;
  }

  get volumeFlowrateUom(): string {
      const uom = this.uoms.find(uom => uom.codeInternal === UNITS.VOLUME_FLOWRATE);
      return uom ? uom.uomDisplay : UNITS.VOLUME_FLOWRATE;
  }

  get ppmUom(): string {
      const uom = this.uoms.find(uom => uom.codeInternal === UNITS.PPM);
      return uom ? uom.uomDisplay : UNITS.PPM;
  }

  get pressureUom(): string {
      const uom = this.uoms.find(uom => uom.codeInternal === UNITS.PRESSURE);
      return uom ? uom.uomDisplay : UNITS.PRESSURE;
  }

  get cubicFlowrateUom(): string {
    const uom = this.uoms.find(uom => uom.codeInternal === UNITS.CUBIC_FLOWRATE);
    return uom ? uom.uomDisplay : UNITS.CUBIC_FLOWRATE;
  }

}